module.exports = __webpack_public_path__ + "img/aParty_032523_D.d3080d36.jpg";